import React, { useState, useEffect } from 'react'
import styles from '../CreateForumModal/CreateForumModal.module.scss'

const CreateThreadModal = ({ isOpen, onClose, onSubmit, forumName }) => {
  const [formData, setFormData] = useState({
    title: '',
    content: ''
  })
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.title.trim()) {
      newErrors.title = 'Заголовок темы обязателен'
    }

    if (!formData.content.trim()) {
      newErrors.content = 'Содержание обязательно'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    setLoading(true)
    try {
      const submitData = {
        title: formData.title.trim(),
        content: formData.content.trim()
      }

      await onSubmit(submitData)
      
      setFormData({
        title: '',
        content: ''
      })
      setErrors({})
      onClose()
    } catch (error) {
      console.error('Ошибка создания темы:', error)
      setErrors({
        submit: error.response?.data?.detail || 'Ошибка создания темы'
      })
    } finally {
      setLoading(false)
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick} data-lenis-prevent>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div className={styles.headerContent}>
            <span className={styles.icon}>📝</span>
            <div>
              <h2>Создать новую тему</h2>
              {forumName && (
                <p style={{ 
                  margin: '4px 0 0 0', 
                  fontSize: '13px', 
                  color: 'rgba(255,255,255,0.6)',
                  fontWeight: 400
                }}>
                  в форуме: {forumName}
                </p>
              )}
            </div>
          </div>
          <button 
            className={styles.closeButton}
            onClick={onClose}
            type="button"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="title">
              Заголовок темы <span className={styles.required}>*</span>
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="О чем будет обсуждение?"
              className={errors.title ? styles.inputError : ''}
              disabled={loading}
            />
            {errors.title && (
              <span className={styles.errorMessage}>{errors.title}</span>
            )}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="content">
              Содержание <span className={styles.required}>*</span>
            </label>
            <textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              placeholder="Опишите вашу тему подробнее..."
              rows={8}
              className={errors.content ? styles.inputError : ''}
              disabled={loading}
            />
            {errors.content && (
              <span className={styles.errorMessage}>{errors.content}</span>
            )}
          </div>

          {errors.submit && (
            <div className={styles.submitError}>
              {errors.submit}
            </div>
          )}

          <div className={styles.formActions}>
            <button
              type="button"
              onClick={onClose}
              className={styles.cancelButton}
              disabled={loading}
            >
              Отмена
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Создание...' : '📝 Создать тему'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CreateThreadModal
